
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import Logo from '@/base-components/Logo.vue';
import store from '@/store';
import config from '@/config.json';

@Options({
  components: { Logo },
  computed: {
    ...mapGetters(['getJsonData', 'currentUser']),
    showRegisterButton() {
      return config.showRegisterButton;
    },
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  },
  methods: {
    logout() {
      store.dispatch('logoutUser');
    },
    openAuth() {
      store.commit('SET_AUTH_MODAL', { visible: true, mode: 'register' });
    }
  }
})
export default class AccountView extends Vue {}
